// extracted by mini-css-extract-plugin
export default {"container":"ai-mobile_container__vn8y3"};